import request from '@/utils/request'

// ========== 计提生成页面接口 ==========

/**
 * 查询计提数据列表
 */
export function queryProvisionData(data) {
  return request({
    url: '/api/booking-service/provisionData/query',
    method: 'post',
    data
  })
}

/**
 * 生成计提
 */
export function generateProvision(data) {
  return request({
    url: '/api/booking-service/provisionData/generate',
    method: 'post',
    data
  })
}

/**
 * 校准
 */
export function calibrate(uuids) {
  return request({
    url: '/api/booking-service/provisionData/calibrate',
    method: 'post',
    data: uuids
  })
}

/**
 * 取消校准
 */
export function unCalibrate(uuids) {
  return request({
    url: '/api/booking-service/provisionData/unCalibrate',
    method: 'post',
    data: uuids
  })
}

/**
 * 发布
 */
export function publish(uuids) {
  return request({
    url: '/api/booking-service/provisionData/publish',
    method: 'post',
    data: uuids
  })
}

/**
 * 取消发布
 */
export function unpublish(uuids) {
  return request({
    url: '/api/booking-service/provisionData/unPublish',
    method: 'post',
    data: uuids
  })
}

/**
 * 重新计算
 */
export function recalculate(uuids) {
  return request({
    url: '/api/booking-service/provisionData/recalculate',
    method: 'post',
    data: uuids
  })
}

// ========== 计提查询页面接口 ==========

/**
 * 查询计提明细列表
 */
export function queryProvisionDetail(data) {
  return request({
    url: '/api/booking-service/provisionData/queryDetailList',
    method: 'post',
    data
  })
}

/**
 * 提出异议
 */
export function submitObjection(data) {
  return request({
    url: '/api/booking-service/provisionData/submitObjection',
    method: 'post',
    data
  })
}

/**
 * 调整金额
 */
export function adjustAmount(data) {
  return request({
    url: '/api/booking-service/provisionData/adjustAmount',
    method: 'post',
    data
  })
}

/**
 * 获取业务详情列表（分页）
 */
export function getJobDetailList(data) {
  return request({
    url: '/api/booking-service/provisionData/getJobDetailList',
    method: 'post',
    data
  })
}

/**
 * 检查订单计提发布状态
 */
export function checkJobProvisionFlag(jobId) {
  return request({
    url: '/api/booking-service/provisionData/checkJobProvisionFlag',
    method: 'get',
    params: { jobId }
  })
}

export function normalizeProvisionLock(data) {
  return {
    etdLocked: !!(data && data.etdLocked),
    feeLocked: !!(data && data.feeLocked)
  }
}

export function deleteProvision(uuids) {
  return request({
    url: '/api/booking-service/provisionData/delete',
    method: 'post',
    data: uuids
  })
}

export function queryBatchPersonDetails(provisionUuid) {
  return request({
    url: '/api/booking-service/provisionData/queryBatchPersonDetails',
    method: 'get',
    params: { provisionUuid }
  })
}
